var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.63 12.6673C21.3912 5.26591 30.3891 0.500429 40.5 0.5C40.8978 0.499983 41.2794 0.658011 41.5607 0.939317C41.842 1.22062 42 1.60216 42 2C42 12.1113 37.2346 21.11 29.833 26.8717C29.943 27.5657 30 28.2766 30 29C30 36.4558 23.9558 42.5 16.5 42.5C15.6716 42.5 15 41.8284 15 41V32.7369C14.9815 32.7236 14.9633 32.7098 14.9453 32.6955C13.0413 31.1858 11.316 29.4605 9.80624 27.5565C9.79154 27.538 9.77732 27.5191 9.76357 27.5H1.5C0.671573 27.5 0 26.8284 0 26C0 18.5442 6.04416 12.5 13.5 12.5C14.224 12.5 14.9354 12.5571 15.63 12.6673ZM27 11C24.5147 11 22.5 13.0147 22.5 15.5C22.5 17.9853 24.5147 20 27 20C29.4853 20 31.5 17.9853 31.5 15.5C31.5 13.0147 29.4853 11 27 11Z",
    fill: "url(#paint0_linear_935_1632)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52073 31.9837C8.18475 31.4883 8.32148 30.5484 7.82613 29.8844C7.33078 29.2204 6.39092 29.0837 5.72691 29.579C3.16418 31.4908 1.5 34.5512 1.5 37.9998C1.5 38.5509 1.54259 39.0931 1.62491 39.623C1.72518 40.2684 2.23149 40.7747 2.87685 40.8749C3.40673 40.9573 3.9489 40.9998 4.5 40.9998C7.94868 40.9998 11.009 39.3357 12.9208 36.7729C13.4162 36.1089 13.2794 35.1691 12.6154 34.6737C11.9514 34.1784 11.0115 34.3151 10.5162 34.9791C9.14627 36.8155 6.96163 37.9998 4.5 37.9998C4.5 35.5382 5.68436 33.3536 7.52073 31.9837Z",
    fill: "url(#paint1_linear_935_1632)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_1632",
    x1: -2.96685e-7,
    y1: 38.771,
    x2: 42.7661,
    y2: 36.0304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_935_1632",
    x1: -2.96685e-7,
    y1: 38.771,
    x2: 42.7661,
    y2: 36.0304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocket-icon.9f4455c8a7bf08bace1758cbe3221d4d.svg";
export { ForwardRef as ReactComponent };